module.exports = __webpack_public_path__ + "img/MasterCard.bdcb615c.svg";